import orderBy from 'lodash/orderBy'
import { observer } from 'mobx-react'
import { FC, useMemo } from 'react'

import { CaseRecordType } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { CheckboxBasedFilter, OptionsProps } from '@avantstay/backoffice-core'

import { FiltersProps } from '@new/domains/operations/screens/CasesV2/CasesV2.types'
import { casesFilterOptionsStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFilterOptionsStore'
import { casesFiltersStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFiltersStore'
import { CaseFilterIds } from '@new/domains/operations/screens/CasesV2/utils/config'
import {
  buildTaxonomyTaskOptions,
  OLD_TAXONOMY_GROUP,
  TaxonomyFilterLevel,
} from '@new/domains/operations/screens/CasesV2/utils/taxonomyFilterOptions'
import { parseLabel } from '@new/domains/operations/utils/parseLabel'

import * as S from './commonFilterStyles.style'
import { useTaxonomyColumnFilter } from './useTaxonomyColumnFilter'

const oldTaxonomyOptions: OptionsProps<string>[] = orderBy(
  Object.values(CaseRecordType).map(recordType => ({
    value: recordType,
    label: parseLabel(recordType.trim()),
    group: OLD_TAXONOMY_GROUP,
    hasFullWidth: true,
  })),
  'label',
)

const _RecordTypeFilter: FC<FiltersProps> = props => {
  const { recordTypes, taxonomyRecordTypes } = casesFiltersStore
  const { taxonomyTasks, isLoadingTaxonomyTasks } = casesFilterOptionsStore

  const taxonomyOptions = useMemo(
    () => orderBy(buildTaxonomyTaskOptions(taxonomyTasks), 'label'),
    [taxonomyTasks],
  )

  const options = useMemo(() => [...taxonomyOptions, ...oldTaxonomyOptions], [taxonomyOptions])

  const { initialValue, handleDataFilter } = useTaxonomyColumnFilter({
    legacyFilterId: CaseFilterIds.RecordType,
    level: TaxonomyFilterLevel.Tasks,
    legacyValues: recordTypes,
    taxonomyValues: taxonomyRecordTypes,
    taxonomyOptions,
  })

  return (
    <S.CheckBoxWrapper optionsLength={options.length}>
      <CheckboxBasedFilter
        {...props}
        shouldGroupBy
        isLoadingOptions={isLoadingTaxonomyTasks}
        title="Record Types"
        options={options}
        initialValue={initialValue}
        shouldUpdateOnInitialValueChange
        onChange={handleDataFilter}
      />
    </S.CheckBoxWrapper>
  )
}

export const RecordTypeFilter = observer(_RecordTypeFilter)
